module.exports = __webpack_public_path__ + "static/media/MenSolidFormalSlimShirt.94cda7db.jpeg";